import { render } from "./FlashMessage.vue?vue&type=template&id=39ad43ae"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/FlashMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39ad43ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39ad43ae', __exports__)) {
    api.reload('39ad43ae', __exports__)
  }
  
  module.hot.accept("./FlashMessage.vue?vue&type=template&id=39ad43ae", () => {
    api.rerender('39ad43ae', render)
  })

}


export default __exports__